import { IDataEndPoint, IEntityEndPoints, IFieldOptions, IFormOptions, IGridOptions, IColumnOptions, IEntityOptions } from '@framework/interfaces/IEntity';
import * as app from '@framework/app';
import * as models from '@common/domain/models/RoleSiteDTO';
import { IApiServiceCommand } from '@services/api/api.service';
export class RoleSiteEndPoints implements IEntityEndPoints {
	list?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/roleSite"}, method: "GET" };
	get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/roleSite/" + serviceCommand.context.entityId}, method: "GET" };
	update?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/roleSite/update/" + serviceCommand.context.entityId}, method: "POST" };
	search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/roleSite/lazy/"}, method: "POST" };
	pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/roleSite/lazyCount/"}, method: "POST" };
	insert?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/roleSite/create"}, method: "POST" };
	delete?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/roleSite/delete/"+ serviceCommand.context.entityId}, method: "POST" };
}

export class RoleSiteFormFields extends Array<IFieldOptions> {
	public id: IFieldOptions = { field: "id" };
	public status: IFieldOptions = { field: "status" };
	public datestamp: IFieldOptions = { field: "datestamp" };
	public changedById: IFieldOptions = { field: "changedById" };
	public roleId: IFieldOptions = { field: "roleId" };
	public siteId: IFieldOptions = { field: "siteId" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.roleId);
		this.push(this.siteId);
	}
}

export class RoleSiteForm implements IFormOptions {
	protected roleSiteFormName: string = "roleSiteForm";
	protected roleSiteFormModel: models.RoleSiteDTO = new models.RoleSiteDTO();
	protected roleSiteFormEndPoints: RoleSiteEndPoints = new RoleSiteEndPoints();
	protected roleSiteFormFields: RoleSiteFormFields = new RoleSiteFormFields();
	public get name(): string { return this.roleSiteFormName };
	public get model(): models.RoleSiteDTO { return this.roleSiteFormModel };
	public get endPoints(): IEntityEndPoints { return this.roleSiteFormEndPoints };
       public set endPoints(roleSiteEndPoints: IEntityEndPoints) {
		this.roleSiteFormEndPoints = roleSiteEndPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.get };
	public get fields(): RoleSiteFormFields { return this.roleSiteFormFields };
}

export class RoleSiteListColumns extends Array<IColumnOptions> {
	public id: IColumnOptions = { field: "id" };
	public status: IColumnOptions = { field: "status" };
	public datestamp: IColumnOptions = { field: "datestamp", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public changedById: IColumnOptions = { field: "changedById" };
	public roleId: IColumnOptions = { field: "roleId" };
	public siteId: IColumnOptions = { field: "siteId" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.roleId);
		this.push(this.siteId);
	}
}

export class RoleSiteList implements IGridOptions {
	protected roleSiteListName: string = "roleSiteList";
	protected roleSiteListModel: models.RoleSiteDTO = new models.RoleSiteDTO();
	protected roleSiteListEndPoints: RoleSiteEndPoints = new RoleSiteEndPoints();
	protected roleSiteListColumns: RoleSiteListColumns = new RoleSiteListColumns();
	public roleSiteForm: RoleSiteForm = new RoleSiteForm();
	public get name(): string { return this.roleSiteListName };
	public get model(): models.RoleSiteDTO { return this.roleSiteListModel };
	public get endPoints(): IEntityEndPoints { return this.roleSiteListEndPoints };
	public set endPoints(roleSiteEndPoints: IEntityEndPoints) {
		this.roleSiteListEndPoints = roleSiteEndPoints;
		this.roleSiteForm.endPoints = this.endPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
	public get columns(): RoleSiteListColumns { return this.roleSiteListColumns };
}

export class RoleSiteEntity implements IEntityOptions {
	protected roleSiteEntityName: string = "roleSiteEntity";
	protected roleSiteEntityModel: models.RoleSiteDTO = new models.RoleSiteDTO();
	protected roleSiteEntityEndPoints: RoleSiteEndPoints = new RoleSiteEndPoints();
	protected roleSiteEntityList: RoleSiteList = new RoleSiteList();
	public get name(): string { return this.roleSiteEntityName };
	public get model(): models.RoleSiteDTO { return this.roleSiteEntityModel };
	public get endPoints(): IEntityEndPoints { return this.roleSiteEntityEndPoints };
	public set endPoints(roleSiteEndPoints: IEntityEndPoints) {
		this.roleSiteEntityEndPoints = roleSiteEndPoints;
		this.grid.endPoints = this.endPoints;
	};
	public get grid(): RoleSiteList { return this.roleSiteEntityList };
	public get form(): RoleSiteForm { return this.grid.roleSiteForm };
	constructor(name?: string) {
		if (name) this.roleSiteEntityName = name;
		this.endPoints = this.roleSiteEntityEndPoints;
	}
};
//export class RoleSiteGeneratedForm extends MfGeneratedFormComponent {
 // protected detailPageComponentForm: RoleSiteForm = new RoleSiteForm();
//};

//export class RoleSiteListPageComponent extends ListPageComponent {
  //protected listPageComponentList: RoleSiteList = new  RoleSiteList();
  //protected showFilterColOnTable: boolean = true;
//};

//export class RoleSiteBlade extends MfBladeComponent {
  //protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: RoleSiteGeneratedForm}];
//};

//export class RoleSiteListBlade extends MfBladeComponent {
 // protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: RoleSiteListPageComponent, isMenuHidden: true }];
//};

